import * as React from 'react';
import { st, classes } from './CheckboxGroup.st.css';
import { Checkbox } from '../Checkbox';
import { Fieldset } from '../internal/Fieldset';
import {
  CheckboxGroupDefaultProps,
  CheckboxGroupLayout,
  CheckboxGroupProps,
} from './types';
import uniqueId from '../../common/uniqueId';

export class CheckboxGroup extends React.Component<CheckboxGroupProps> {
  private readonly _errorMessageId: string;
  static displayName = 'CheckboxGroup';
  static defaultProps: CheckboxGroupDefaultProps = {
    layout: CheckboxGroupLayout.Vertical,
  };

  constructor(props) {
    super(props);
    this._errorMessageId = uniqueId('error-message');
  }

  render() {
    const {
      label,
      layout,
      error,
      disabled,
      errorText,
      className,
      newErrorMessage,
      fluid,
      lang,
    } = this.props;
    const stStates = { disabled, layout, error, newErrorMessage, fluid };
    const isErrorMessageProvided = errorText && errorText.length > 0;

    return (
      <Fieldset
        errorMessage={newErrorMessage && error && errorText}
        errorMessageId={this._errorMessageId}
        data-hook={this.props['data-hook']}
        className={st(classes.root, stStates, className)}
        label={label}
        lang={lang}
      >
        <div className={classes.wrapper}>
          {React.Children.map(
            this.props.children,
            (child: Checkbox, idx: number) => {
              if (!React.isValidElement(child)) {
                return null;
              }
              return (
                <>
                  {React.cloneElement(child, {
                    key: idx,
                    error,
                    disabled,
                    className: st(classes.checkboxItem, child.props.className),
                  })}
                </>
              );
            },
          )}
        </div>
        {error && isErrorMessageProvided && !disabled && !newErrorMessage && (
          <span className={classes.error}>{errorText}</span>
        )}
      </Fieldset>
    );
  }
}
